import { Box, Typography } from "@mui/material";

export default function LastLoginUserSection({ entityData }) {
  return (
    <>
      {entityData?.crowdstrike_data?.last_login_username && (
        <Box display="flex" flexDirection="column" gap={2}>
          <Typography variant="subtitle2">Last Login User</Typography>
          <Typography variant="caption">
            {entityData.crowdstrike_data.last_login_username}
          </Typography>
        </Box>
      )}
    </>
  );
}
